import moment from 'moment';

export function guessTimezone() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone ?? moment.tz.guess(true);
}
